import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { HelpCircle, Mail, MessageCircle, BookOpen } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

export default function HelpPage() {
  return (
    <div className="@container/help max-w-[1800px] w-full mx-auto px-3 py-4 @[740px]/help:px-4 @[740px]/help:py-5 @[1100px]/help:px-6 @[1100px]/help:py-6 space-y-4 @[740px]/help:space-y-5 @[1100px]/help:space-y-6">
      <div className="space-y-3 @[740px]/help:space-y-4">
        <h1 className="text-xl @[740px]/help:text-2xl @[1100px]/help:text-3xl font-bold">Help Center</h1>
        <p className="text-muted-foreground text-lg">
          Find answers to common questions and get support for Dominion Mandate.
        </p>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Card>
          <CardHeader>
            <HelpCircle className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Getting Started</CardTitle>
            <CardDescription>
              New to the platform?
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div>
              <h3 className="font-semibold text-sm mb-1">How do I create an account?</h3>
              <p className="text-xs text-muted-foreground">
                Click "Sign Up" and create your account with your email, password, and name.
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-sm mb-1">How do I sign in?</h3>
              <p className="text-xs text-muted-foreground">
                Use your email and password, or sign in with a magic link sent to your email address.
              </p>
            </div>
            <Link to="/auth/signup">
              <Button variant="outline" size="sm" className="w-full mt-2">
                Sign Up
              </Button>
            </Link>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <BookOpen className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Watching Streams</CardTitle>
            <CardDescription>
              Learn how to access content
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div>
              <h3 className="font-semibold text-sm mb-1">How do I watch live streams?</h3>
              <p className="text-xs text-muted-foreground">
                Once signed in, navigate to the "Streams" page to see all available live and 
                recorded content.
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-sm mb-1">Can I watch on mobile?</h3>
              <p className="text-xs text-muted-foreground">
                Yes! Our platform is fully responsive and works on all devices including 
                smartphones and tablets.
              </p>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <MessageCircle className="h-8 w-8 text-primary mb-2" />
            <CardTitle>Account & Settings</CardTitle>
            <CardDescription>
              Manage your account
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-3">
            <div>
              <h3 className="font-semibold text-sm mb-1">How do I change my password?</h3>
              <p className="text-xs text-muted-foreground">
                Use the "Forgot Password" link on the sign-in page to reset your password.
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-sm mb-1">How do I update my profile?</h3>
              <p className="text-xs text-muted-foreground">
                Go to your Profile page from the dashboard to update your information.
              </p>
            </div>
            <div>
              <h3 className="font-semibold text-sm mb-1">How do I delete my account?</h3>
              <p className="text-xs text-muted-foreground mb-2">
                You can request account deletion by visiting our Account Deletion Request page.
              </p>
              <a href="/account-deletion-request">
                <Button variant="outline" size="sm" className="w-full">
                  Request Account Deletion
                </Button>
              </a>
            </div>
          </CardContent>
        </Card>
      </div>

      <Card>
        <CardHeader>
          <Mail className="h-8 w-8 text-primary mb-2" />
          <CardTitle>Still Need Help?</CardTitle>
          <CardDescription>
            Contact our support team
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground mb-4">
            If you can't find the answer you're looking for, our support team is here to help.
          </p>
          <div className="space-y-3">
            <a 
              href="mailto:streaming@dominioncity.org.za" 
              className="flex items-center gap-3 text-sm text-primary hover:underline"
            >
              <Mail className="h-4 w-4" />
              streaming@dominioncity.org.za
            </a>
            <p className="text-xs text-muted-foreground">
              We typically respond within 24-48 hours during business days.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
